import React, { useMemo } from 'react';
import { ChecklistDataEntry, MopedChecklistType, StudentChecklistValue } from './types';
import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import Table from './Table';
import ChecklistValueCell from './ChecklistValueCell';

type MopedChecklistDataEntry = ChecklistDataEntry & {
	theoryExam: StudentChecklistValue;
	practicalExam: StudentChecklistValue;
};

const columnHelper = createColumnHelper<MopedChecklistDataEntry>();

const MopedChecklist = ({ checklist }: { checklist: MopedChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('theoryExam', {
				header: 'Theorie-examen',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalExam', {
				header: 'Praktijkexamen',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			theoryExam: entry.values.find((value) => value.option.name === 'Theorie-examen') || {
				value: null,
			},
			practicalExam: entry.values.find((value) => value.option.name === 'Praktijkexamen') || {
				value: null,
			},
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default MopedChecklist;
